/**
 * The app-icon badge (the red number on the icon), on both channels.
 *
 * Web / Home Screen web app: the browser's Badging API. Store app: the
 * Badge plugin (@capawesome/capacitor-badge, installed in the shell from
 * native 1.1.0 — reached through the bridge like the other native plugins,
 * so the CRM build carries no dependency on it). A store build without the
 * plugin rejects the call and nothing happens, which is what it did before.
 */
import { Capacitor, registerPlugin } from "@capacitor/core";

const Badge = registerPlugin("Badge");

const MAX_SHOWN = 99;

export async function setAppBadge(count) {
  const n = Math.max(0, Math.min(MAX_SHOWN, Math.floor(Number(count) || 0)));
  if (Capacitor.isNativePlatform()) {
    try {
      if (n === 0) await Badge.clear();
      else await Badge.set({ count: n });
    } catch {
      /* older store build without the plugin */
    }
    return;
  }
  try {
    if (n === 0) {
      if (navigator.clearAppBadge) await navigator.clearAppBadge();
    } else if (navigator.setAppBadge) {
      await navigator.setAppBadge(n);
    }
  } catch {
    /* unsupported browser */
  }
}

export const clearAppBadge = () => setAppBadge(0);
